const DB = "dwtf_keystore",
  ST = "keys",
  ID = "current_user",
  /** v2 repairs empty v1 DBs (old is.ag hasLocalKey without onupgradeneeded). */
  VER = 2;

export type StoredKey = {
  id: string;
  privateKeyB64: string;
  publicKeyB64: string;
  userId?: string;
  created_at: number;
};

function open(): Promise<IDBDatabase> {
  return new Promise((ok, bad) => {
    if (typeof indexedDB === "undefined") return bad(new Error("idb"));
    const r = indexedDB.open(DB, VER);
    const t = setTimeout(() => bad(new Error("idb")), 4e3);
    r.onupgradeneeded = () => {
      if (!r.result.objectStoreNames.contains(ST)) r.result.createObjectStore(ST, { keyPath: "id" });
    };
    r.onsuccess = () => {
      clearTimeout(t);
      ok(r.result);
    };
    r.onerror = () => {
      clearTimeout(t);
      bad(r.error ?? new Error("idb"));
    };
  });
}

export async function saveKey(key: Omit<StoredKey, "id"> & { id?: string }) {
  const db = await open();
  try {
    await new Promise<void>((ok, bad) => {
      const tx = db.transaction(ST, "readwrite");
      tx.objectStore(ST).put({ ...key, id: key.id ?? ID });
      tx.oncomplete = () => ok();
      tx.onerror = () => bad(tx.error ?? new Error("save"));
    });
  } finally {
    db.close();
  }
}

/** null if missing or IDB broken — fail-open for UI. */
export async function getKey(): Promise<StoredKey | null> {
  try {
    const db = await open();
    try {
      return await new Promise<StoredKey | null>((ok, bad) => {
        const r = db.transaction(ST, "readonly").objectStore(ST).get(ID);
        r.onsuccess = () => ok((r.result as StoredKey) ?? null);
        r.onerror = () => bad(r.error ?? new Error("get"));
      });
    } finally {
      db.close();
    }
  } catch {
    return null;
  }
}

export async function clearKey() {
  try {
    const db = await open();
    try {
      await new Promise<void>((ok, bad) => {
        const tx = db.transaction(ST, "readwrite");
        tx.objectStore(ST).delete(ID);
        tx.oncomplete = () => ok();
        tx.onerror = () => bad(tx.error ?? new Error("clear"));
      });
    } finally {
      db.close();
    }
  } catch {
    /* */
  }
}
